 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		59: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		59: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "j/" + ({"0":"lib-components-flexonry~lib-tools-responsive~lib-tools-transitions~lib-utilities-anchors~src-compone~04fe734c","1":"vendors~lib-components-carousel~src-components-about-about~src-components-books-creation~src-compone~d12c66cf","2":"lib-components-forms","3":"src-components-carousel","4":"lib-components-richtext","5":"lib-utilities-typography","6":"src-components-books-creation~src-components-books-purchase","7":"vendors~lib-components-richtext~src-components-richtext","8":"lib-components-carousel","9":"lib-components-dynamic_fields","10":"lib-components-flexonry","11":"lib-components-instafeed","12":"lib-tools-dom","13":"lib-tools-events","14":"lib-tools-fetch","15":"lib-tools-images","16":"lib-tools-responsive","17":"lib-tools-scrolling","18":"lib-tools-transitions","19":"lib-tools-urls","20":"lib-utilities-anchors","21":"lib-utilities-scroll_preventer","22":"src-components-404","23":"src-components-about-about","24":"src-components-about-books","25":"src-components-background","26":"src-components-books-admin","27":"src-components-books-creation","28":"src-components-books-detail","29":"src-components-books-purchase","30":"src-components-books-web","31":"src-components-cart","32":"src-components-colourful_carousel","33":"src-components-common","34":"src-components-footer","35":"src-components-forms","36":"src-components-header","37":"src-components-holding","38":"src-components-homepage","39":"src-components-instafeed","40":"src-components-journal","41":"src-components-menu","42":"src-components-orders","43":"src-components-pages","44":"src-components-reviews","45":"src-components-richtext","46":"src-components-staticpage","47":"src-utilities-cart","48":"src-utilities-currency","49":"src-utilities-typography","50":"src-utilities-videoplayer","51":"vendors~src-components-books-admin","52":"vendors~src-components-common","53":"[request]"}[chunkId]||chunkId) + "." + {"0":"4daba54bd089cd250bf6","1":"beb531bad443ebbd9f9f","2":"473a9718a2b014a5da40","3":"bad554c688ad674c562b","4":"35ea6251d50687b7bdb7","5":"2469ab370fecb3ed1541","6":"fc02da0326124e863933","7":"af515a0492938926013d","8":"df92d6e75fae5f086181","9":"c9ee30483ef5cd2557f9","10":"bd1cdf969f103ec5ec74","11":"a04d77cfbe2e6d9fa2e4","12":"c17e37b4d661c87471d3","13":"78a123fc61f38f1b9161","14":"8546639d973ea31768aa","15":"d4dd5769549aedfba466","16":"f5319fd1f4b7f96f482b","17":"da1a71d95d616f2e3a08","18":"8ddc2bf550393b2b557f","19":"82248fd5f5e6bb23a326","20":"8c618d02501e99b15530","21":"b41b799b3a7b473df014","22":"32c461b92ad757b8ab38","23":"f82a1b24d829c5905247","24":"86369bfd9c626ea9fc64","25":"1266d4aaf8e75bba9769","26":"4c650a40cc78f262b1f1","27":"c031fab0f5005e5ec19b","28":"897934c7c19cf2293071","29":"ae7ea632c19b0115f0f1","30":"730bed77c9851670aa66","31":"b3850afbc8cbf2a5e5f5","32":"f8fb78a25f87aad64c2b","33":"ce82d8399ef3e96bedf0","34":"6576792c7e665ea27c25","35":"001bae0eea2da2bbc6ad","36":"db49e151117f18a7ae63","37":"d5dd536c3ee7675a65ea","38":"fea86d0225c31cdd4536","39":"0a24264390891467ba64","40":"b9d1f4858d1641653d6b","41":"286d0bd6a7325f4a4128","42":"81f007116899ab024338","43":"b8befe6e147266fa39cc","44":"1e2a8a25560666376941","45":"16b8d62cd76ae776431d","46":"3e61502d41f6d5ef585a","47":"826ee7229e7581fcd6d1","48":"48713b4b132f0b335fe9","49":"17c361c04446af7bad1b","50":"3590322419137451f0d3","51":"0418fc4dd61c22461285","52":"6ba5a3a44c198dc2b464","53":"8872a9ed5e51fc496157"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"5":1,"6":1,"7":1,"8":1,"10":1,"11":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"46":1,"50":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "c/" + ({"0":"lib-components-flexonry~lib-tools-responsive~lib-tools-transitions~lib-utilities-anchors~src-compone~04fe734c","1":"vendors~lib-components-carousel~src-components-about-about~src-components-books-creation~src-compone~d12c66cf","2":"lib-components-forms","3":"src-components-carousel","4":"lib-components-richtext","5":"lib-utilities-typography","6":"src-components-books-creation~src-components-books-purchase","7":"vendors~lib-components-richtext~src-components-richtext","8":"lib-components-carousel","9":"lib-components-dynamic_fields","10":"lib-components-flexonry","11":"lib-components-instafeed","12":"lib-tools-dom","13":"lib-tools-events","14":"lib-tools-fetch","15":"lib-tools-images","16":"lib-tools-responsive","17":"lib-tools-scrolling","18":"lib-tools-transitions","19":"lib-tools-urls","20":"lib-utilities-anchors","21":"lib-utilities-scroll_preventer","22":"src-components-404","23":"src-components-about-about","24":"src-components-about-books","25":"src-components-background","26":"src-components-books-admin","27":"src-components-books-creation","28":"src-components-books-detail","29":"src-components-books-purchase","30":"src-components-books-web","31":"src-components-cart","32":"src-components-colourful_carousel","33":"src-components-common","34":"src-components-footer","35":"src-components-forms","36":"src-components-header","37":"src-components-holding","38":"src-components-homepage","39":"src-components-instafeed","40":"src-components-journal","41":"src-components-menu","42":"src-components-orders","43":"src-components-pages","44":"src-components-reviews","45":"src-components-richtext","46":"src-components-staticpage","47":"src-utilities-cart","48":"src-utilities-currency","49":"src-utilities-typography","50":"src-utilities-videoplayer","51":"vendors~src-components-books-admin","52":"vendors~src-components-common","53":"[request]"}[chunkId]||chunkId) + "." + {"0":"4daba54bd089cd250bf6","1":"beb531bad443ebbd9f9f","2":"473a9718a2b014a5da40","3":"bad554c688ad674c562b","4":"35ea6251d50687b7bdb7","5":"2469ab370fecb3ed1541","6":"fc02da0326124e863933","7":"af515a0492938926013d","8":"df92d6e75fae5f086181","9":"c9ee30483ef5cd2557f9","10":"bd1cdf969f103ec5ec74","11":"a04d77cfbe2e6d9fa2e4","12":"c17e37b4d661c87471d3","13":"78a123fc61f38f1b9161","14":"8546639d973ea31768aa","15":"d4dd5769549aedfba466","16":"f5319fd1f4b7f96f482b","17":"da1a71d95d616f2e3a08","18":"8ddc2bf550393b2b557f","19":"82248fd5f5e6bb23a326","20":"8c618d02501e99b15530","21":"b41b799b3a7b473df014","22":"32c461b92ad757b8ab38","23":"f82a1b24d829c5905247","24":"86369bfd9c626ea9fc64","25":"1266d4aaf8e75bba9769","26":"4c650a40cc78f262b1f1","27":"c031fab0f5005e5ec19b","28":"897934c7c19cf2293071","29":"ae7ea632c19b0115f0f1","30":"730bed77c9851670aa66","31":"b3850afbc8cbf2a5e5f5","32":"f8fb78a25f87aad64c2b","33":"ce82d8399ef3e96bedf0","34":"6576792c7e665ea27c25","35":"001bae0eea2da2bbc6ad","36":"db49e151117f18a7ae63","37":"d5dd536c3ee7675a65ea","38":"fea86d0225c31cdd4536","39":"0a24264390891467ba64","40":"b9d1f4858d1641653d6b","41":"286d0bd6a7325f4a4128","42":"81f007116899ab024338","43":"b8befe6e147266fa39cc","44":"1e2a8a25560666376941","45":"16b8d62cd76ae776431d","46":"3e61502d41f6d5ef585a","47":"826ee7229e7581fcd6d1","48":"48713b4b132f0b335fe9","49":"17c361c04446af7bad1b","50":"3590322419137451f0d3","51":"0418fc4dd61c22461285","52":"6ba5a3a44c198dc2b464","53":"8872a9ed5e51fc496157"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"3": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"4": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"8": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"10": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"11": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"12": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"22": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"23": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"24": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"25": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"27": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"28": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"29": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"30": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"31": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"33": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"36": [
 				0,
 				20,
 				5,
 				49,
 				47,
 				48
 			],
 			"38": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"39": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"40": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"41": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"42": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"43": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"45": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"46": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"50": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			],
 			"53": [
 				0,
 				20,
 				5,
 				49,
 				36,
 				47,
 				48
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "8D23");
